// ADDED
import React, { useState } from "react";
import ClinicRequirementsTable from "./components/ClinicRequirementsTable";
import ClinicRequirementsAddEditModal from "./components/ClinicRequirementsAddEditModal";
import { SearchBar, Button } from "../../../../common/APICommon";
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';

const ClinicRequirementsModule = ({
  user,
  data,
  loading,
  searchData,
  createRequirement,
  updateRequirement
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleSearch = (value) => {
    setCurrentPage(1);
    searchData(value);
  };

  const handleSave = async (form) => {
    if (selectedItem) {
      const audit = [{
        setupArea: "Clinic Requirement",
        actionTaken: "update",
        field: "Description",
        newValue: form.description,
        oldValue: selectedItem.description,
        dateSaved: new Date(),
        savedById: user.id
      }];
      const res = await updateRequirement(selectedItem.id, form, audit);
      if (res.success) setIsModalOpen(false);
    } else {
      const audit = {
        setupArea: "Clinic Requirement",
        actionTaken: "insert",
        field: "Add",
        newValue: form.description,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      };
      const res = await createRequirement(form, audit);
      if (res.success) setIsModalOpen(false);
    }
  };

  return (
    <div className='p-4 space-y-4 relative'>
      <div className="flex justify-between items-center">
        <SearchBar handleFilter={handleSearch} />
        <Button
          icon={<MedicalServicesIcon />}
          name={"Add Requirement"}
          className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
          onClick={() => { setSelectedItem(null); setIsModalOpen(true); }}
        />
      </div>

      <ClinicRequirementsTable
        data={data}
        onEdit={handleEdit}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      <ClinicRequirementsAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
      />
    </div>
  );
};

export default ClinicRequirementsModule;